/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-03 11:17:24
 */
import ColumnTypes from '@/utils/ColumnTypes';
function getColumns(that) {
	let arr = [
		{
			key: 'shopName',
			label: '店铺名称',
			type: () => import('./components/tableCells/shopNameCell.vue'),
			minWidth: '130',
			fixed: 'left',
			isShow: true,
		},
		{
			key: 'outerShopId',
			label: '店铺ID',
			type: () => import('./components/tableCells/TextCell.vue'),
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'shopScore',
			label: '商家综合分',
			type: () => import('./components/tableCells/shopScoreCell.vue'),
			minWidth: '120',
			isShow: true,
		},
		{
			key: 'cooperativeProductCount',
			label: '合作商品数',
			helpNum: 1,
			helpDesc1: '该店铺提报的商品，且未被删除至回收站，次日更新',
			sortable: 'cooperativeProductCount',
			type: ColumnTypes.TextCell,
			minWidth: '160',
			isShow: true,
		},
		{
			key: 'orderProductCount',
			label: '30日出单商品数',
			helpNum: 1,
			helpDesc1: '该店铺30日出单商品数，次日更新',
			sortable: 'orderProductCount',
			type: ColumnTypes.TextCell,
			minWidth: '180',
			isShow: true,
		},
		{
			key: 'sampleCount',
			label: '寄样数',
			sortable: 'sampleCount',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'sales30Days',
			label: '30日销售额',
			helpNum: 1,
			helpDesc1: '该店铺30日出单订单金额之和，次日更新',
			sortable: 'sales30Days',
			type: () => import('./components/tableCells/salesCell.vue'),
			minWidth: '160',
			isShow: true,
		},
		{
			key: '',
			label: '对接人',
			helpNum: 1,
			helpDesc1: '来控制店铺内商品的审核人，支持单个招商负责审核',
			type: () => import('./components/tableCells/followUpCell.vue'),
			minWidth: '160',
			isShow: that.$isPlatOr(that.platformId, ['Dy', 'Ks']) && that.followUpState,
		},
		// {
		// 	key: 'estimatedServiceFee30Days',
		// 	label: '30日预估服务费',
		// 	helpNum: 1,
		// 	helpDesc1: '该店铺30日出单订单服务费收入之和，次日更新',
		// 	sortable: 'estimatedServiceFee30Days',
		// 	type: () => import('./components/tableCells/salesCell.vue'),
		// 	minWidth: '180',
		// 	isShow: true,
		// },
		{
			key: 'collaborativeStatus',
			label: '协作状态',
			type: () => import('./components/tableCells/statusCell.vue'),
			minWidth: '90',
			isShow: true,
		},
		{
			key: 'remarks',
			label: '备注',
			type: () => import('./components/tableCells/TextCell.vue'),
			minWidth: '130',
			isShow: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '380',
			align: 'right',
			mode: 'vertical',
			fixed: 'right',
			isShow: true,
		},
	];
	return arr.filter(item => item.isShow);
}
export default getColumns;
